export const KEY = {
  ENTER: {
    name: 'Enter',
    code: 13,
  },
  ESCAPE: {
    name: 'Escape',
    code: 27,
  },
  SPACE: {
    name: 'Space',
    code: 32,
  },
}
